import { Injectable } from '@angular/core';
import {BaseProviderService} from "../base-provider.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {NovaCotacao} from "../../aplicacao/models/nova-parceria/nova-cotacao.model";

@Injectable({
  providedIn: 'root'
})
export class ParceriaService extends BaseProviderService {
  module = 'Parceria';
  model = new NovaCotacao();
  modelListaProposta;
  idProposta: string;
  idCotacao: number;
  constructor(protected http: HttpClient) {
    super(http);
  }

  get(id: string): Observable<NovaCotacao> {
    return this.http.get<NovaCotacao>(this.getUrl(this.v2, this.module, ['OfertaParceiro', id]))
      .pipe(map(x => new NovaCotacao(x)));
  }

  getTotalizadorMenu(): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v2, this.module, ['TotalRegistrosPorTipoPesquisa']))
      .pipe(map(x => x));
  }

  deletarDocumento(id: number): Observable<any> {
    return this.http.delete<any>(this.getUrl(this.v2, this.module, ['OfertaParceiro', 'DeletarDocumento', id])).pipe();
  }

  listaPropostas(id: string): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v2, this.module, ['Parceiro', 'ListaProposta', id]))
      .pipe(map(x => x));
  }
}

